import script from "./DashboardEnquiries.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardEnquiries.vue?vue&type=script&setup=true&lang=js"

import "./DashboardEnquiries.vue?vue&type=style&index=0&id=0e3bd3fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3bd3fd"]])

export default __exports__